// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
			//suggestionMode: 'test',
			//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	InstantSearchMobile.prototype.afterShowSearchBoxMobile = function(searchBoxId) {
		if (!searchBoxId) searchBoxId = this.searchBoxId;
		// Hide debut's search bar on mobile, and show our search bar instead
		// if(jQ('.js-drawer-close').length > 0){
		// 	setTimeout(function() {
		// 		jQ('.js-drawer-close').trigger('click');
		// 	});
		// }

    window.closeDrawers();
	};

	SearchInput.prototype.customizeInstantSearch= function() {
		// Hide debut's search suggestion
		if (jQ('.predictive-search-wrapper').length > 0){
				jQ('.predictive-search-wrapper').hide();
		}
	};

	function closeSuggestionMobile(searchBoxId, isCloseSearchBox) {
		/* console.log('closeSuggestionMobile'); */
		jQ(searchBoxId).autocomplete('close');
		jQ('.' + Class.searchSuggestion + '[data-search-box="' + searchBoxId + '"]').parent().hide();
		// Remove search box
		var isCloseSearchBox = typeof isCloseSearchBox !== 'undefined' ? isCloseSearchBox : false;
		if (isCloseSearchBox) jQ('.boost-pfs-search-suggestion-mobile-top-panel,.boost-pfs-search-suggestion-mobile-overlay').hide();
		// Update current term for all search boxes
		setValueAllSearchBoxes();
		// Add back tabindex=-1
		jQ('.boost-pfs-search-no-tabindex').attr('tabindex', -1);
		// Return scrolling of body
		if(jQ('body').hasClass(Class.searchSuggestionMobileOpen)){    
			jQ('body').removeClass(Class.searchSuggestionMobileOpen);
		}
		BoostPFS.afterCloseSuggestionMobile(searchBoxId, isCloseSearchBox);
	
		// Close search theme debut
		if(jQ('.js-drawer-close').length > 1){
			jQ('.js-drawer-close').trigger('click');
		}
	}
  
  	InstantSearchResultBlockViewAll.prototype.compileTemplate = function() {
		// Build content when total_product > 0
		// If the request is did_you_mean, get the number from suggest_total_product
		var totalProduct = Utils.getValueInObjectArray('total_product', this.data);
		var suggestTotalProduct = Utils.getValueInObjectArray('suggest_total_product', this.data);
		if (suggestTotalProduct !== '') totalProduct = suggestTotalProduct;
		// Check if total_product > display number of products
		var suggestionBlocks = Settings.getSettingValue('search.suggestionBlocks');
		var displayProductNumber = Utils.getValueInObjectArray('products', suggestionBlocks, 'type', 'number');
		if (totalProduct == 0) {
			return '';
		}
		// Build search page URL
		this.viewAllTerm = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.SUGGEST_QUERY, this.data);
		if (!this.viewAllTerm) this.viewAllTerm = Utils.getValueInObjectArray(InstantSearchEnum.ResultType.QUERY, this.data);
		var viewAllUrl = Utils.reBuildUrlBaseOnLocale('/search?' + Globals.searchTermKey + '=' + Utils.encodeURIParamValue(this.viewAllTerm));
		return this.getTemplate()
			.replace(/{{class.searchSuggestionHeader}}/g, Class.searchSuggestionHeader)
			.replace(/{{label.suggestion.viewAll}}/g, Labels.suggestion.viewAll)
			.replace(/{{ count }}/g, totalProduct)
			.replace(/{{viewAllUrl}}/g, viewAllUrl);
	}
})();